export default {
    'title.accountCreation'             : 'Spordle Gateway | Account Creation',
    'title.payment'                     : 'Spordle Gateway | Payment',
    'title.loading'                     : 'Loading...',
    'title.cart.title'                  : 'Cart',
    'title.review.title'                : 'Review',
}